import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import { GROUP_SUBSCRIPTION_TEAM } from '../src/constants';
import {
  CancelTeamSubscriptionParams,
  CancelTeamSubscriptionResponse,
  GROUP_SUBSCRIPTION_KEY,
  cancelTeamSubscription,
} from '../utils/backend-api/groupSubscription';

export default function useTeamSubscriptionCancel() {
  const queryClient = useQueryClient();
  const { mutate, isLoading, isError } = useMutation(
    (params: CancelTeamSubscriptionParams) => cancelTeamSubscription(params),
    {
      onSuccess: (data: CancelTeamSubscriptionResponse) => {
        queryClient.invalidateQueries([GROUP_SUBSCRIPTION_KEY, GROUP_SUBSCRIPTION_TEAM]);
        if (data.success) {
          toast.success('Subscription has been canceled');
        } else {
          toast.error('Subscription has not been canceled, please try again');
        }
      },
      onError: () => {
        toast.error('Subscription has not been canceled, please try again');
      },
    }
  );
  return { mutate, isLoading, isError };
}
